export default __webpack_public_path__ + "static/media/flowsTrigger.ebc92495.svg";